import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'createdAt')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
      ], 64))
    : (_ctx.column.key === 'initiatorName' && _ctx.row.initiator)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.row.initiator.name), 1)
        ], 64))
      : (_ctx.column.key === 'initiatorEmail' && _ctx.row.initiator)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.row.initiator.email), 1)
          ], 64))
        : (_ctx.column.key === 'statusName' && _ctx.row.status)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 3,
              class: _normalizeClass(["small", `small font-bold ${_ctx.getCheapClass}`])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.row.status.name), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : (_ctx.column.key === 'statusCode' && _ctx.row.status)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.row.status.code), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
              ], 64))
}